import { booleanAttribute, Component, input, Input, ChangeDetectionStrategy } from '@angular/core';
import { TimelineSegment, TimelineSegmentItem } from '@splixer/player';
import { Pv2TrackInfoComponent } from '../track-info/track-info.component';

@Component({
  selector: 'pv2-segment-timeline',
  templateUrl: 'segment-timeline.component.html',
  styleUrl: '../player-v2-styles.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Pv2TrackInfoComponent],
})
export class Pv2SegmentTimelineComponent {
  @Input({ required: true }) timelineSegment: TimelineSegment | undefined;
  @Input() currentTrack: TimelineSegmentItem | undefined; // Current track which has yet to be pushed into the timeline segment
  public contentOnly = input(true, { transform: booleanAttribute });
  public displaySegmentInfo = input(false, { transform: booleanAttribute });
}
